import { render, staticRenderFns } from "./Assunto.vue?vue&type=template&id=127ef446&scoped=true"
import script from "./Assunto.vue?vue&type=script&lang=ts"
export * from "./Assunto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ef446",
  null
  
)

export default component.exports